<template>
  <el-container>
    <el-main>
      <div class="content-container">
        <check-list :checkList="accessDataArr" @refresh="refresh" @skip="busiCheck" v-if="showPreCheckList">
        </check-list>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import oppService from "../../service/opp-service";
import custService from "../../service/cust-service";
import checkList from "../../components/common/preCheckList";
import { openView } from "../../service/record-service";
import stringConfig from "../../tools/stringConfig";
import flowService from "@/service/flow-service";

export default {
  data () {
    return {
      isLoading: true,
      accessDataArr: [],
      checkFlag: false,
      routeTable: [],
      showPreCheckList: false, //是否展示准入列表
      newBusiCode: this.busiCode,
    };
  },
  mounted () {
    this.mountedInitData();
  },
  watch: {
    isLoading (v) {
      if (v) {
        this.myLoading({
          
          loadingText: "正在核对您的资料&请稍候...",
          autoHide: false
        });
      } else {
        this.myLoading({
          showLoading: false
        });
      }
    }
  },
  props: ["busiCode", "userType"],
  components: {
    checkList
  },
  computed: {
    isProfInvest () {//是否 专业投资者 用来隐藏适当性匹配 
      let custInfo = this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO) || {};
      if (["V0132", "V0148"].includes(this.busiCode)) {
        //金融产品双录 不隐藏适当性匹配  
        return false;
      } else {
        return ["10", "11", "12"].includes(custInfo.PROF_INVESTOR_SOURCE);
      }
    },
    bizConfig () {
      return this.$bizcfg.getBizConfig(this.newBusiCode, this.userType);
    },
    pageCount () {
      return "pageCount" in this.bizConfig && this.bizConfig["pageCount"]
        ? this.bizConfig["pageCount"]
        : 10;
    },
    isLogin () {
      return this.$store.state.isLogin;
    },
    isOpenAccount () {
      return this.$syscfg.isOpenAcctBiz(this.newBusiCode);
    },
    busiName () {
      return this.$storage.getSession(this.$definecfg.BUSI_NAME);
    },
    customerInfo () {
      return this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO) || {};
    },
  },
  methods: {
    async mountedInitData () {
      this.myLoading({
        
        loadingText: "正在核对您的资料&请稍候...",
        autoHide: false
      });
      if (!this.busiCode) {
        consoleLog("业务代码不能为空");
        this.confirm({
          messageText: "业务代码不能为空,请重新进入!",
          confirmedAction: () => {
            this.$router.push({ path: "/login" });
          }
        });
        return;
      }
      // 初始化清除业务信息
      this.$storage.removeSession(this.$definecfg.BUSI_INFO);
      this.$store.commit(this.$types.UPDATE_OLD_BIZ_DATA, {});

      // 校查当前业务客户类型是否匹配
      let filterList = _.filter(this.bizConfig.infoList, function (item) {
        return item.id == this.userType;
      }.bind(this));
      if (!filterList.length && !_.startsWith(this.newBusiCode, "P")) {
        this.isLoading = false;
        let errMsg = this.userType == 0 ? "个人客户"
          : this.userType == 1 ? "机构客户"
            : "产品客户";
        errMsg += "无需办理此业务！";
        this.alert({
          messageText: errMsg,
          confirmedAction: () => {
            this.goToHome();
          }
        });
        return;
      }
      let that = this;
      oppService.getBusiCommonParams(this.newBusiCode).then(data => {
        //保存业务定义
        return oppService.getBusiDefInfo(that.newBusiCode).then(function (data) {
          that.$storage.setSession(that.$definecfg.BUSI_DEF_INFO, data || {});
          that.$storage.setSession(
            that.$definecfg.BUSI_SCOPE,
            data.BUSI_SCOPE || "1"
          );
          that.initCheck();
        });
      }).catch(err => {
        that.isLoading = false;
        consoleLog("业务公共参数获取失败,路由初始化失败!原因：" + err);
        that.alert({
          messageText: "业务公共参数获取失败,路由初始化失败!",
          confirmedAction: () => {
            that.goToHome();
          }
        });
      });
    },
    initCheck () {
      // 初始化业务路由表
      this.initRoutes()
        .then(() => {
          if (
            this.$syscfg.isOpenAcctBiz(this.newBusiCode)
          ) {
            //
            //开户 调用黑名单校验。实名制，重点监控对象，流水状态拦截
            this.checkRule();
            // this.$router.goRoute(this.getFirstShowPageIndex())
          } else {
            // 客户规范性检查
            // 重新获取客户信息以保证业务执行使用最新客户信息（客户业务办理完后不用重新登录）

            this.getCustomerInfo(
              this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO)
                .CUST_CODE
            ).then(data => {
              // 保存客户信息到session里
              consoleLog("保存客户数据，ID_CODE==", data.custAllInfo.BASIC_INFO.ID_CODE);
              this.$storage.setLocal(this.$definecfg.CUST_ALL_INFO, data.custAllInfo);
              this.$storage.setSession(this.$definecfg.CUSTOMER_INFO, data.custAllInfo.BASIC_INFO);
              this.$storage.setSession(this.$definecfg.F_CUST_ORG_CODE, data.custAllInfo.BASIC_INFO.INT_ORG);
              this.checkRule();
            }).catch((err) => {
              consoleError("保存客户数据失败",err);
              this.alert({
                messageText: err,
                confirmButtonText: "返回首页",
                confirmedAction: () => {
                  this.$router.replace({ "path": "/home" });
                }
              });
            });
          }
        })
        .catch(err => {
          this.isLoading = false;
          this.alert({
            messageText: "客户准入校验失败，" + err + "，请联系管理员！",
            confirmedAction: () => {
              this.goToHome();
            }
          });
        });
    },
    /**
         * 初始化业务路由配置
         */
    initRoutes () {
      let that = this;
      let isApptBiz = this.$storage.getSession(this.$definecfg.IS_APPT_BIZ);
    
      // 如果路由配置文件中存在当前业务自定义配置，则使用该配置，否则默认给一个资料采集路由
      if ("bizRoutes" in that.bizConfig) {
        if (Array.isArray(that.bizConfig["bizRoutes"])) {
          that.routeTable = _.concat(that.routeTable, _.cloneDeep(that.bizConfig["bizRoutes"]));
        } else {
          that.routeTable = _.concat(that.routeTable, _.cloneDeep(that.bizConfig["bizRoutes"][that.$syscfg.getStandardUserType(that.userType, that.busiCode)]) || []);
        }
      } else {
        that.routeTable.push({
          name: "资料采集",
          path: "/bizFlow/:busiCode/:userType"
        });
      }

      let bcs = [];
      let reqList = [];
      // 规范化业务代码和用户类型
      for (let i = 0; i < that.routeTable.length; i++) {
        let r = that.routeTable[i];
        r.original_path = r.path;
        r.path = r.path
          .replace(":userType", that.userType)
          .replace(":busiCode", that.busiCode);
        // 路由默认属性设置
        that.setDefaultValue(i);

        // 非定制化业务，跳转至bizEntry，过滤出当前业务的所有子业务
        if (
          _.startsWith(r.path, "/bizFlow") &&
          (_.split(r.path, "/").length == 4)
        ) {
          let bc = _.split(r.path, "/")[2];
          if (bcs.indexOf(bc) == -1) {
            bcs.push(bc);
            reqList.push(
              new Promise((resolve, reject) => {
                resolve(that.getPages(bc, that.userType));
              })
            );
          }
        }
      }

      // 获取业务配置，自动化分页业务
      return that.$syscfg.K_Request_ALL(reqList).then(res => {
        let allPages = {},
          baseIndex = 0,
          acctIndex = 0,
          creditIndex = 0,
          permIndex = 0,
          pwdResetIndex = 0,
          evaluatingNodeIndex = 0,
          custVisitIndex = 0,
          orgPartnerIndex = 0,
          openAcctInfoNodeIndex = 0,
          agentInfoNodeIndex = 0,
          keyInfoNodeIndex = 0,
          normalInfoNodeIndex = 0,
          custMatchResultNodeIndex = 0,

          videoWitnessInfoNodeIndex = 0,
          secondRouterObj = {},
          navRouterTable = [];
        for (let i = 0; i < res.length; i++) {
          let bc = bcs[i];
          let pages = res[i];
          allPages[bc] = pages;
        }

        for (let i = 0; i < that.routeTable.length; i++) {
          let r = that.routeTable[i];
          // 自定义业务路由配置，页面内容根据自定义配置展示（路由项中的modules可以不写，自动读取--没什么用处，一般都写了。而且bizEntry后的数值为了后续拓展方便，都按照10位递增，和这里的判断对不上）
          if (_.startsWith(r.path, "/bizFlow")) {
            let bc = _.split(r.path, "/")[2];
            if (r.path.indexOf("/bizEntry/") > 0) {
              let idx = parseInt(_.last(_.split(r.path, "/")));
              if (bc in allPages && idx < allPages[bc].length) {
                that.routeTable[i] = Object.assign(allPages[bc][idx], r);
              }
            }
            // 默认路由，页面内容根据自动分页计算结果展示
          } else if (_.split(r.path, "/").length == 4) {
            let bc = _.split(r.path, "/")[2];
            let newPages = [];
            if (bc in allPages) {
              for (let j = 0; j < allPages[bc].length; j++) {
                let p = _.cloneDeep(r);
                p.name = allPages[bc][j].name;
                p.path += "/bizEntry/" + j;
                p = Object.assign(allPages[bc][j], p);
                newPages.push(p);
              }
            }

            that.routeTable.splice(i, 1);
            for (let j = 0; j < newPages.length; j++) {
              that.routeTable.splice(i + j, 0, newPages[j]);
            }
          }
          if (!r.from) {
            let rc = _.split(r.path, "/")[4];
            switch (rc) {
              case "baseInfoNode":
                that.routeTable[i]["stepIndex"] = baseIndex;
                baseIndex++;
                break;
              case "acctInfoNode":
                that.routeTable[i]["stepIndex"] = acctIndex;
                acctIndex++;
                break;
              case "creditInvestNode":
                that.routeTable[i]["stepIndex"] = creditIndex;
                acctIndex++;
                break;
              case "permInfoNode":
                that.routeTable[i]["stepIndex"] = permIndex;
                permIndex++;
                break;
              case "orgPartner":
                that.routeTable[i]["stepIndex"] = orgPartnerIndex;
                orgPartnerIndex++;
                break;
              case "custVisitNode":
                that.routeTable[i]["stepIndex"] = custVisitIndex;
                custVisitIndex++;
                break;
              case "openAcctInfoNode":
                that.routeTable[i]["stepIndex"] = openAcctInfoNodeIndex;
                openAcctInfoNodeIndex++;
                break;
              case "agentInfoNode":
                that.routeTable[i]["stepIndex"] = agentInfoNodeIndex;
                agentInfoNodeIndex++;
                break;
              case "keyInfoNode":
                that.routeTable[i]["stepIndex"] = keyInfoNodeIndex;
                keyInfoNodeIndex++;
                break;
              case "normalInfoNode":
                that.routeTable[i]["stepIndex"] = normalInfoNodeIndex;
                normalInfoNodeIndex++;
                break;
              case "evaluatingNode":
                that.routeTable[i]["stepIndex"] = evaluatingNodeIndex;
                evaluatingNodeIndex++;
                break;
              case "custMatchResultNode":
                that.routeTable[i]["stepIndex"] = custMatchResultNodeIndex;
                custMatchResultNodeIndex++;
                break;
              case "videoWitnessInfoNode":
                that.routeTable[i]["stepIndex"] = videoWitnessInfoNodeIndex;
                videoWitnessInfoNodeIndex++;
                break;
              default:
                break;
            }
          } else {
            if (secondRouterObj[r.from]) {
              secondRouterObj[r.from].push(r);
            } else {
              secondRouterObj[r.from] = [];
              secondRouterObj[r.from].push(r);
            }
          }
        }

        if (!_.isEmpty(secondRouterObj)) {
          _.forEach(secondRouterObj, (value, key) => {
            _.forEach(value, (secondVal, secondIndex) => {
              _.forEach(that.routeTable, ritem => {
                if (ritem.path == secondVal.path) {
                  ritem["stepIndex"] = secondIndex;
                }
              });
            });
          });
        }
        // 添加默认的影像采集节点和业务结束节点
        // that.routeTable.push({
        //   name: "影像采集",
        //   path: "/imageAcquisition",
        //   show: true
        // });
        that.routeTable.splice(0, 0, 
          {
            // 默认第一页为业务准入检查页面
            name: "业务准入检查",
            path: "/bizCheck/:busiCode/:userType",
            ignorePrev: true,
            hideNavStep: true,
            show:true
          }
        );
        // that.routeTable.push({
        //   name: "业务受理成功",
        //   path: "/bizComplete",
        //   show: true
        // });
       
        that.$store.commit(that.$types.UPDATE_BIZ_ROUTE_INDEX, -1);
        that.$store.commit(that.$types.UPDATE_BIZ_ROUTE_TABLE, that.routeTable);
      });
    },
    /**
     * 设置路由的默认属性
     */
    setDefaultValue (index) {
      let that = this;
      // show 当前节点是否显示
      !("show" in that.routeTable[index]) && (that.routeTable[index]["show"] = true);
      // ignorePrev 为true时，上一步跳过此路由
      !("ignorePrev" in that.routeTable[index]) && (that.routeTable[index]["ignorePrev"] = false);
      // ignoreNext 为true时，下一步跳过此路由
      !("ignoreNext" in that.routeTable[index]) && (that.routeTable[index]["ignoreNext"] = false);
      // ignoreFieldCheck 为true时，跳过所有字段关联逻辑检查,目前用于开户业务，加载客户历史数据时
      !("ignoreFieldCheck" in that.routeTable[index]) && (that.routeTable[index]["ignoreFieldCheck"] = false);
      // checkFieldChange 为true时，检查字段变更情况，通常用于资料变更业务， 新开不显示还原按钮。
      (!("checkFieldChange" in that.routeTable[index]) || _.isEmpty(that.customerInfo.CUST_CODE)) && (that.routeTable[index]["checkFieldChange"] = false);
      // beginFieldValidate 为true时，在业务页面初始化后就触发校验字段正确 默认不校验
      !("beginFieldValidate" in that.routeTable[index]) && (that.routeTable[index]["beginFieldValidate"] = false);
      // beginFieldRuels 为true时，在业务页面初始化后就触发校验字段关联逻辑 默认为执行
      !("beginFieldRuels" in that.routeTable[index]) && (that.routeTable[index]["beginFieldRuels"] = true);
      // isCommit 为true时，此路由提交数据，通常用于bizEntry页面控制是否提交数据
      !("isCommit" in that.routeTable[index]) && (that.routeTable[index]["isCommit"] = true);
      // isHideTmpSave 为true 隐藏暂存按钮
      !("isHideTmpSave" in that.routeTable[index]) && (that.routeTable[index]["isHideTmpSave"] = false);
      // prevBtnText 上一步按钮配置
      !("prevBtnText" in that.routeTable[index]) && (that.routeTable[index]["prevBtnText"] = "上一步");
      // nextBtnText 下一步按钮配置
      !("nextBtnText" in that.routeTable[index]) && (that.routeTable[index]["nextBtnText"] = "下一步");
    },
    getPages (busiCode, userType) {
      let reqList = [
        this.getGroupCfg(busiCode, userType),
        this.getPreCfg(busiCode, userType)
      ];

      return Promise.all(reqList).then(res => {
        let groupCfg = res[0],
          groupDatas = res[1];

        if (groupCfg.Code != "0") {
          throw groupCfg.Msg;
        }

        if (groupDatas.Code != "0") {
          throw groupDatas.Msg;
        }

        if (groupDatas.Data.length == 0 && groupCfg.Data.length == 0) {
          throw "当前业务无预录入页面配置信息，业务终止";
        }

        // 初始化页面渲染数据结构
        groupDatas = groupDatas.Data[0];
        let groupPage = [];
        groupCfg.Data.sort(this.by("GROUP_SEQ")).map(group => {
          if (
            group.BUSI_PLAT &&
            group.BUSI_PLAT.split(",").indexOf(this.$basecfg.bizPlatform) == -1
          )
            return; // 过滤掉不是当前业务平台的配置

          let groupDataTemp = groupDatas[group.GROUP_ID];
          let modules = {};
          groupPage.push([]);
          let gpIdx = groupPage.length - 1;
          Object.values(groupDataTemp)
            .map(groupArr => {
              return groupArr[0];
            })
            .sort(this.by("MODULE_SEQ"))
            .map(item => {
              if (
                (item.GROUP_BUSI_PLAT &&
                  item.GROUP_BUSI_PLAT.split(",").indexOf(
                    this.$basecfg.bizPlatform
                  ) == -1) ||
                (item.MODULE_BUSI_PLAT &&
                  item.MODULE_BUSI_PLAT.split(",").indexOf(
                    this.$basecfg.bizPlatform
                  ) == -1)
              )
                return; // 过滤掉不是当前业务平台的配置

              let fields_temp = {};
              // 判断模块分组的字段数量（默认两个字段占一行，标题占一行）
              groupPage[gpIdx].push({
                group_name: group.GROUP_TITLE,
                group: item.GROUP_ID,
                module: item.MODULE_ID,
                count: _.ceil(_.keys(item.FIELDS).length / 2) + 1
              });
              modules[item.MODULE_ID] = [item];
            });
          groupDatas[group.GROUP_ID] = modules;
        });

        return this.calcPages(groupPage);
      });
    },
    calcPages (groupPage) {
      // 根据一柜通配置计算分页
      let result = [];
      for (let k = 0; k < groupPage.length; k++) {
        let arr = groupPage[k];
        let tempArr = [];
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].count >= this.pageCount) {
            if (tempArr.length) {
              result.push(this.getPageModules(tempArr));
              tempArr = [];
            }

            result.push(this.getPageModules([arr[i]]));
          } else {
            let totalCount = 0;
            for (let j = 0; j < tempArr.length; j++) {
              totalCount += tempArr[j].count;
            }

            totalCount += arr[i].count;
            if (totalCount > this.pageCount) {
              result.push(this.getPageModules(tempArr));
              tempArr = [arr[i]];
            } else {
              tempArr.push(arr[i]);
            }
          }

          if (i == arr.length - 1 && tempArr.length > 0) {
            result.push(this.getPageModules(tempArr));
          }
        }
      }

      return result;
    },
    getFirstShowPageIndex () {
      for (let i = 0; i < this.routeTable.length; i++) {
        if (this.routeTable[i].show) {
          return i;
        }
      }
      return -1;
    },
    getPageModules (arr) {
      let result = {},
        moduleArr = [],
        groupId = "",
        title = "";
      arr.map(item => {
        moduleArr.push(item.module);
        groupId = item.group;
        name = item.group_name;
      });

      result["name"] = name;
      result["group"] = groupId;
      result["modules"] = moduleArr;
      return result;
    },
    getGroupCfg: function (busiCode, userType) {
      // 获取分组配置
      return this.$syscfg.K_Request("F0000027", {
        BUSI_CODE: busiCode,
        USER_TYPE: userType
      });
    },
    // 获取预录入字段配置（分组、模块、字段）
    getPreCfg: function (busiCode, userType) {
      return oppService.F0000028({
        BUSI_CODE: busiCode,
        USER_TYPE: userType
      });
    },
    getBizCfg: function (busiCode) {
      // 获取业务配置，查看是否影像配置
      return this.$syscfg.K_Request("F0000029", {
        BUSI_CODE: busiCode
      });
    },
    by: function (name) {
      // 用于数组字典排序
      return function (o, p) {
        let a, b;
        if (typeof o === "object" && typeof p === "object" && o && p) {
          a = o[name];
          b = p[name];
          if (a === b) {
            return 0;
          }
          a = parseInt(a);
          b = parseInt(b);
          return a < b ? -1 : 1;
        } else {
          throw "error";
        }
      };
    },
    async checkRule () {
      let that = this;
      let customerInfo = that.$storage.getJsonSession(that.$definecfg.CUSTOMER_INFO) || {},
        isExteral = this.$store.state.isExteral;
      let data = {
        CUST_CODE: customerInfo.CUST_CODE || "",
        CUST_NAME: customerInfo.CUST_NAME,
        CUST_FNAME: customerInfo.CUST_FNAME,
        BUSI_CODE: that.newBusiCode,
        BUSI_SCOPE: 2,
        USER_TYPE: isExteral ? "99" : customerInfo.USER_TYPE, //外部客户调用准入时不能传正常用户类型
        ID_TYPE: customerInfo.ID_TYPE,
        ID_CODE: customerInfo.ID_CODE,
        IS_DOUBLE_RECORD: that.isdoubleRecord,
        INT_ORG: customerInfo.INT_ORG
      };
      //2021/4/21 VTM-3040 新需求 前置校验之前需要先检查流水是否是驳回给工作人员，如果是跳过前置校验，规范性检查跟业务准入
      //为了避免重复查询流水，所以提取公共的流水获取逻辑，并提前到这里查询，bizcheck那边不再查询流水
      let bizDataList = (await flowService.initBiz(that, that.newBusiCode, that.userType)) || [],
        bizData = bizDataList[0] || {};

      //业务流程查询续 不检查多笔流水
      let bsno = that.$storage.getSession(that.$definecfg.B_SNO) || "";
      if (bsno) {
        bizData = _.find(bizDataList, v => v.B_SNO === bsno) || {};
      }
      //VTM-8793 产品户开户允许多笔同时录入
      // if (!proBSno && bizDataList.length && that.$syscfg.isProOpenAcctBiz(that.newBusiCode)) {
      //   bizData = await that.checkBizDataList(bizDataList);
      // }
      if (bizData && bizData.B_SNO) {
        let startTimeData = await flowService.getBusiStartOpenTime(that, bizData.B_SNO);
        bizData.START_OPEN_TIME = startTimeData;
      }
      // 7*24小时改造-客户识别成功后，资料变更业务/期权开户不再校验是否中登查询时间，删除非中登查询时间禁止办理业务拦截项；
      // let needCsdcArr = ["V0016", "V0018", "V0017", "V0143", "V0117", "V0115"];
      if (bizData) {
        consoleLog("获取到旧的流水数据，状态为", bizData.PROC_STATUS);
        let busiInfo = await oppService.parseAcceptParam(bizData);
        that.$storage.setSession(that.$definecfg.BUSI_INFO, busiInfo);
        that.$store.commit(that.$types.UPDATE_OLD_BIZ_DATA, bizData);

        this.$storage.setSession(this.$definecfg.CUSTOMER_INFO, Object.assign(customerInfo, {
          CUST_CODE: customerInfo.CUST_CODE || _.get(busiInfo, "BIZ_DATA.NEW_CUST_CODE","") || "",
          CUST_FNAME: customerInfo.CUST_FNAME ||  _.get(busiInfo, "BIZ_DATA.KEY_INFO.NEW_CUST_FNAME","") || "",
          ID_CODE: customerInfo.ID_CODE || _.get(busiInfo, "BIZ_DATA.KEY_INFO.NEW_ID_CODE","") || "",
          ID_TYPE: customerInfo.ID_TYPE ||  _.get(busiInfo, "BIZ_DATA.KEY_INFO.NEW_ID_TYPE","") || "",
        }));
      }
      //开始进行正常的前置校验，规范性检查，准入校验
      // that.getAccesData(data, bizData)
      //   .then(function (finallResultFlag) {
      //     if (finallResultFlag) {
      that.gotoNext();
      //   } else {
      //     that.showPreCheckList = true;
      //   }
      // }).catch(err => {
      //   that.isLoading = false;
      //   that.alert({
      //     messageText: "客户准入校验失败，" + err + "，请联系管理员！",
      //     confirmedAction: () => {
      //       that.goToHome();
      //     }
      //   });
      // })
      // .finally(() => {
      //   that.isLoading = false;
      //   that.myLoading({
      //     showLoading: false
      //   });
      // });
    },
    getAccesDataByAcctType (params, type) {
      let that = this,
        newParams = _.cloneDeep(params);
      consoleLog("准入类型", type);
      // 公参配置了业务不需要规范性检查则不复用缓存的规范性检查数据
      let noCustInfoCheck = oppService.getBusiCommonParamsFromCacheObjs("NO_CUST_INFO_CHECK");
      if (noCustInfoCheck !== "1" && !that.checkFlag && type == 1 && !!that.$store.state.customerCheckResult) {
        //如果缓存里保存了规范性校验结果，则直接复用
        consoleLog("复用缓存结果", that.$store.state.customerCheckResult);
        return Promise.resolve(that.dealResultData(type, that.$store.state.customerCheckResult));
      }
      return that.$syscfg.K_Request("W0000129", Object.assign(newParams, {
        ACCESS_TYPE: type,
        INT_ORG: newParams.INT_ORG,
        CUACCT_STATUS: that.$storage.getSession(that.$definecfg.CUACCT_STATUS)
      })).then(function (result) {
        if (result.Code != "0") {
          throw result.Msg;
        }
        /*
        国投如果是前置和规范性检查则展示警告项 可跳过
        其中拒绝项的优先级高于禁止项，禁止项的优先级高于警告项，当有拒绝项时，仅展示拒绝项对应的关联业务链接，不展示禁止和警告项的关联业务链接，避免客户误点，同理，当无拒绝项，有禁止和警告项时，仅展示禁止项对应的关联业务链接，不展示警告项的关联业务链接。
        */
        let accessDataArr = result.Data;
        let timeOutFlag = type == 1 ? _.get(accessDataArr, "[0].CHECK_RESULT[0].MENU_ID") : _.get(accessDataArr, "[0].MENU_ID");
        if (timeOutFlag === "-99999") {
          //查询超时
          that.alert({
            messageText: "查询失败&请重新查询",
            cancelButtonText: "返回首页",
            cancel_icon: "home",
            confirm_icon: "refresh",
            confirmButtonText: "重新查询",
            confirmedAction: function () {
              that.myLoading({
                
                loadingText: "正在核对您的资料&请稍候...",
                autoHide: false
              });

              // that.jumpTime = 0;
              that.checkRule();
            },
            canceledAction: function () {
              //返回首页
              if (that.isLogin) {
                that.$router.push({ path: "/homeCustomer" });
              } else {
                that.$router.push({ path: "/home" });
              }
            }
          });
          return;
        }
        //国投新逻辑 规范性检查需要缓存结果，只缓存IS_SKIP_STANDARD_CHECK==“0”的
        //IS_SKIP_STANDARD_CHECK==‘1’ 标识此次校验是跳过校验的(比如休眠业务，代理中登业务)，跳过校验的结果(客户资料变更的结果中台过滤了也不完整)不缓存，下次办理其他业务还是需要重新检查
        if (type == 1) {
          if (_.get(accessDataArr, "[0].IS_SKIP_STANDARD_CHECK") == "0" && ["V0049", "V0126", "V0127"].indexOf(that.newBusiCode) == -1) {
            consoleLog("准入结果缓存", _.get(accessDataArr, "[0].CHECK_RESULT", []));
            that.$store.commit(that.$types.UPDATE_CUSTOMER_CHECK_RESULT, _.get(accessDataArr, "[0].CHECK_RESULT", []));
          }
          return that.dealResultData(type, _.get(accessDataArr, "[0].CHECK_RESULT", []));
        }
        return that.dealResultData(type, accessDataArr);
      });
    },
    dealResultData (type, accessDataArr) {
      //国投新逻辑 0前置校验跟1规范性检查 里的警告跟提示都不展示，放到业务完成页面展示
      if (type == 0 || type == 1) {
        accessDataArr = accessDataArr.filter(v => ["0", "1"].includes(v.RESTRICT_TYPE));
      }
      if (type == 1 && ["V0049", "V0126", "V0127"].includes(this.newBusiCode)) {
        //客户资料变更业务 需要过滤掉跳转本身的业务
        accessDataArr = accessDataArr.filter(v => {
          //默认不过滤
          let flag = true;
          //跳转连接里存在客户资料变更就过滤掉该检查项
          _.forEach(v.MENU_LIST || [], busiObj => {
            if (busiObj.BUSI_CODE == "V0049") {
              flag = false;
              return false;
            }
          });
          return flag;
        });
      }
      if (accessDataArr.length > 0) {
        this.accessDataArr = this.accessDataArr.concat(accessDataArr);
        return false;
      } else {
        consoleLog("类型校验通过", type);
        return true;
      }
    },
    async getAccesData (params, bizData = {}) {
      let that = this;
      //国投新需求 客户规范性检查跟前置校验 放到业务完成再检查
      let asyncDataArr = [that.getAccesDataByAcctType(params, 0)];
      //业务跳转携带的参数
      let transBizData = this.$store.state.transBizData || {};
      let acceptParam = !!bizData.ACCEPT_PARAM && JSON.parse(decodeURIComponent(bizData.ACCEPT_PARAM)) || {};
      let isSkipCheck = transBizData.skipCheck == "1" || acceptParam.skipCheck == "1";
      if (isSkipCheck) {
        //允许只校验前置，而跳过规范性以及业务准入，目前只有从客户资料变更跳转到一码通合并业务以及这种情况的业务驳回会用到
        asyncDataArr.push(true);
      } else if (!that.isOpenAccount && !that.$store.state.isExteral) {
        let RESTRICT_TYPE = "0,1";//规范性检查只检查类型，0拒绝办理业务，1禁止办理,不检查2警告，3提示
        asyncDataArr.push(that.getAccesDataByAcctType(Object.assign(_.cloneDeep(params), {
          RESTRICT_TYPE: RESTRICT_TYPE
        }), 1));
      } else {
        asyncDataArr.push(true);
      }

      return Promise.all(asyncDataArr).then(function (checkResult) {
        if (isSkipCheck && checkResult[0]) {
          return true;
        } else if (checkResult[0] && checkResult[1]) {
          consoleLog("前置通过跟规范通过");
          return that.getAccesDataByAcctType(params, 2);
        };
      });
    },
    openBizCheckRule (param) {
      //检查黑名单 中登实名制
      return this.$syscfg.K_Request("F0000030", param);
    },
    getCustomerInfo (custCode) {
      return this.$syscfg
        .K_Request("W0000004", {
          IDENT_CODE: custCode,
          checkPwdFlag: "0",
          IDENT_TYPE: "CUST_CODE",
          BUSI_CODE: this.newBusiCode || "" //传参busiCode用于豁免遗产继承专属式
        })
        .then(response => {
          if (response.Code != "0") {
            switch (response.Code) {
              case "-1005":
                throw "客户账户资料查询失败，请求超时！";
              default:
                throw "客户账户资料查询失败，请联系管理员！";
            }
          } else {
            let data = response.Data && response.Data[0];
            if (data.loginResult.loginFlag == "0") {
              // throw data.loginResult.loginErrorMsg;
              throw data.loginResult.loginErrorMsg || "客户账户资料查询失败，查无此客户!(loginFlag:0)";
            } else if (
              data &&
              data.custAllInfo &&
              data.custAllInfo.BASIC_INFO
            ) {
              return data;
            } else {
              throw "客户账户资料查询失败，查无此客户!";
            }
          }
        });
    },
    goToHome () {
      if (this.isLogin) {
        //已经登录成功且不是销户状态 跳转登录后的首页
        this.$router.replace({
          path: "/homeCustomer"
        });
      } else {
        this.$router.replace({
          path: "/home"
        });
      }
    },
    gotoNext () {
      this.$router.goRoute(this.getFirstShowPageIndex());
    },

    busiCheck () {
      //业务准入检查
      let that = this;
      // if (that.jumpTime > 0) {
      that.gotoNext();
      //   return
      // }
      // that.jumpTime += 1;
      // let customerInfo = that.$storage.getJsonSession(that.$definecfg.CUSTOMER_INFO);
      // let data = {
      //   CUST_CODE: customerInfo.CUST_CODE || "",
      //   CUST_NAME: customerInfo.CUST_FNAME,
      //   BUSI_CODE: that.newBusiCode,
      //   BUSI_SCOPE: 8,
      //   USER_TYPE: customerInfo.USER_TYPE,
      //   ID_TYPE: customerInfo.ID_TYPE,
      //   ID_CODE: customerInfo.ID_CODE,
      //   IS_DOUBLE_RECORD: that.isdoubleRecord,
      //   INT_ORG: customerInfo.INT_ORG
      // };

      // that.showPreCheckList = false;
      // that.accessDataArr = [];
      // that.myLoading({
      //   
      //   loadingText: "正在核对您的资料&请稍候...",
      // });
      // that.getAccesDataByAcctType(data, 2).then(function (isPass) {
      //   if (isPass) {
      //     that.gotoNext();
      //   } else {
      //     that.showPreCheckList = true;
      //   }
      // }).finally(function () {
      //   that.myLoading({ showLoading: false });
      // });
    },
    refresh () {
      let that = this;
      this.isLoading = true;
      this.accessDataArr = [];
      this.routeTable = [];
      this.showPreCheckList = false; //是否展示准入列表
      // this.jumpTime = 0; //准入点击跳过的次数
      this.newBusiCode = this.$store.state.busicode;
      // 点击了重新校验 需要清除缓存,再重新检查
      this.$store.commit(this.$types.UPDATE_CUSTOMER_CHECK_RESULT, null); //默认将规范性检查结果置为空

      //重新查询时，不再重复缓存的校验结果，要重新查。
      that.checkFlag = true;
      that.mountedInitData();
    },
    //展示流水列表数据
    checkBizDataList (dataList) {
      let that = this;
      return new Promise((resolve, reject) => {
        that.confirm({
          msg_icon: "warn-edit",
          messageText: "您有受理中的开户流水，是否续办",
          cancelButtonText: "重新办理",
          confirmButtonText: "续办",
          canceledAction: () => {
            resolve({});
          },
          confirmedAction: () => {
            if (dataList.length === 1) {
              resolve(dataList[0]);
              return;
            }
            that.popup({
              popupType: "proBizList",
              confirmButtonText: "重新办理",
              cancelButtonText: "返回首页",
              hideCloseBtn: true,
              popupInner: {
                title: "请选择要续办的流水",
                bizList: dataList,
                dealButtonTxt: "续办"
              },
              confirmedAction: function (resObj) {
                if (_.isEmpty(resObj)) {
                  resolve({});
                } else {
                  resolve(dataList[resObj.bizIndex]);
                }
              },
              canceledAction: function () {
                that.$router.push({ path: "/home" });
              },
            });
          }
        });
      });
    },
  }
};
</script>

<style lang="less" scoped>
.el-main {
  display: flex;
  align-items: center;
  padding: 0;
}
.content-loading {
  margin: auto;
  padding: 0;
  width: 40.6%;
  height: 174px;
  min-width: 360px;
  text-align: center;
}
.content-container {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  background: #fff;
  border-radius: 4px;
}
.prompt-padding-top {
  display: block;
  height: 78px;
}
.ic-loading {
  // display: block;
  margin: 0 auto;
  width: 36px;
  height: 36px;
  background-image: url("~@img/previous/icons/loading-white.svg");
  background-size: cover;
  margin-bottom: 15px;
  animation: rotation 1s infinite steps(10);
}
.prompt-loading {
  color: white;
  font-size: 28px;
}
.ic-warning {
  display: block;
  margin: 0 auto;
  background-size: cover;
  width: 72px;
  height: 72px;
  background-image: url("~@img/previous/icons/plaint-prompt.svg");
  background-size: cover;
  margin-bottom: 15px;
}
.ic-reload {
  display: block;
  margin: 0 auto;
  width: 72px;
  height: 72px;
  background-image: url("~@img/previous/icons/plaint-prompt.svg");
  background-size: cover;
  margin-bottom: 15px;
}
.prompt-paragraph {
  padding: 0 30px;
  display: block;
  margin-top: 3px;
  font-size: 20px;
  color: #666666;
}
.prompt-paras {
  width: 320px;
  margin-left: auto;
  margin-right: auto;
}
.ic-dropout {
  margin-top: 50px;
  height: 54px;
  width: 162px;
  background: linear-gradient(to right, #4a90e2, #497ee7);
  border-radius: 100px;
  color: #ffffff;
  font-size: 24px;
  border-width: 0px;
}
@-webkit-keyframes rotation {
  from {
    -webkit-transform: none;
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes rotation {
  from {
    transform: none;
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/customerCheck/customerCheck.vue